import styled from "styled-components";

export const ContainerDemandeClient = styled.div`
    background: #FFF;
    border-radius: 14px;
`